import React, {useState, useContext, useEffect, useMemo, useCallback, useReducer, useRef} from 'react'
import { useTranslation } from "react-i18next";
import {GetAlertsComponent,setObjectByPath, validateConstantValues} from "./utils"
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from "@material-ui/core/TextField";
import RulesContext from "../../../../context/rules-context"
import AuthContext from '../../../../context/auth-context';
import _ from "lodash"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import TimeDeltaTextField from './Components/TimeDeltaTextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { Dialog, Typography } from '@mui/material';
import axios from 'axios';
import { dataFetchReducer } from "../../../Utils/requestUtils";
import { trimNestedObject } from '../../../Utils/utils'
import {
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'
import {
    getRegionFromEnvironment,
    getEnvironmentFromRegion,
    FieldsManager,
    HistoricalDataPicker,
    getEventTypesIntersectionAcrossCompanies,
    RULE_PIECE_CURRENT_COMPANY_KEY,
    areFieldsCleared,
    RULE_PIECE_CURRENT_EVENT_ENUM,
    RULE_PIECE_CURRENT_EVENT_ES_INDEX,
    RULE_PIECE_CURRENT_EVENT_ENVIRONMENT,
    RULE_PIECE_CURRENT_EVENT_REGION,
    RULE_PIECE_CURRENT_EVENT_DATE_PATH,
    filterDatasetEntries,
    isCachedDatasetCompatibleWithMappings,
} from './EventFieldShared'

export function EventFieldCachedCounterBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props
    let helperString = "";
    let rulesList = useContext(RulesContext)

    const helperNode = _.cloneDeep(node)
    nodeToV2(helperNode)
    const mappings = helperNode.node.properties.target_event_type?.field_mappings || rulesList.fields_mapper_list || []
    if (helperNode.node.properties.fields && helperNode.node.properties.fields.length > 0) {
        helperString = helperString + helperNode.node.properties.fields.reduce((acc, field, idx, src) => {
            let event = mappings.filter(rule => rule.path === field.target_field_path)[0]
            let description = (event || {description:""}).description
            if (idx === 0) acc = acc + description
            else if (idx === src.length -1 && src.length > 1) acc = acc + " e " + description
            else acc = acc + ", " + description
            return acc
        }, "")
    }

    function formatTimedelta(timedelta) {
        const duration = moment.duration(timedelta);

        const years = duration.years();
        const months = duration.months();
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        let formattedString = '';

        if (years > 0) {
            formattedString += `${years} ${t('years')}`;
        }

        if (months > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${months} ${t('months')}`;
        }

        if (days > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${days} ${t('days')}`;
        }

        if (hours > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${hours} ${t('hours')}`;
        }

        if (minutes > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${minutes} ${t('minutes')}`;
        }

        if (seconds > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${seconds} ${t('seconds')}`;
        }

        return formattedString.trim();
    }

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}}
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Contar")} {t(helperString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ?
                            t("Nos últimos ") + formatTimedelta(helperNode.node.properties.timedelta_value)
                            :
                            t("Em todo o histórico")}
                            </div>
                        </div>
                        {(helperNode.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={helperNode.node.alerts} />  : null}
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(helperNode)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(helperNode)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}}
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Contar")} {t(helperString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ?
                            t("Nos últimos ") + formatTimedelta(helperNode.node.properties.timedelta_value)
                            :
                            t("Em todo o histórico")}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export function EventFieldCachedCounterConfiguration(props){

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 280,
            },
        },
    };

    const CLAMP_HINT_FLASH_MS = 900

    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleNodeChange} = props
    let {handleConfigurationClose} = props
    let {userVariables} = props
    let rulesList = useContext(RulesContext)
    let authContext = useContext(AuthContext)
    const { isRulePiece } = rulesList
    const box_settings = rulesList.boxes[node.node.type]?.settings || {}
    const company = rulesList.company
    let rule_company_key = (rulesList?.company_key && rulesList?.company_key !== "")? rulesList?.company_key : authContext.user_data?.company_key
    const companyList = useMemo(() => (Array.isArray(company) ? company : [company]), [company])

    const rule_event_type = useMemo(() => {
        let ruleEventType = rulesList?.event_type
        if (isRulePiece) {
            let validCompanyEvent = null
            if(isNodeV1(node)) {
                let fieldPaths = [...(node.node.properties.field_paths || [])]
                if (node.node.properties.static_fields?.length) {
                    fieldPaths = [...fieldPaths, ...node.node.properties.static_fields.map(field => field.field_path)]
                }
                for (let company of companyList) {
                    const companyEventCandidate = company.company_events?.find(event =>
                        fieldPaths.every(path =>
                            path && event.field_mapping?.field_mappings?.some(mapping => mapping.path === path)
                        )
                    )
                    if (companyEventCandidate) {
                        validCompanyEvent = companyEventCandidate
                        break
                    }
                }
            }
            else {
                validCompanyEvent = companyList?.[0]?.company_events?.[0]
            }
            ruleEventType = validCompanyEvent?.field_mapping?.event_type
            ruleEventType = {
                ...ruleEventType,
                enum: RULE_PIECE_CURRENT_EVENT_ENUM,
                es_index: RULE_PIECE_CURRENT_EVENT_ES_INDEX,
                rule_company_key: RULE_PIECE_CURRENT_COMPANY_KEY,
                event_date_path: RULE_PIECE_CURRENT_EVENT_DATE_PATH,
            }
        }
        else {
            const ruleCompany = companyList.find(comp => comp.company_key === rule_company_key)
            const ruleRegion = getRegionFromEnvironment(rulesList.environment)
            ruleEventType = ruleCompany?.company_events?.find(event =>
                event.field_mapping.event_type.enum === rulesList?.event_type
            && getRegionFromEnvironment(event.field_mapping.event_type.environment) === ruleRegion
            )?.field_mapping.event_type
        }

        return ruleEventType
    }, [rulesList.event_type, companyList, rule_company_key, rulesList.environment, isRulePiece, node])

    if(rule_event_type?.rule_company_key) {
        rule_company_key = rule_event_type.rule_company_key
    }

    let settingsFilters = box_settings.filters || []

    const [nodeState, setNodeState] = useState(() => {
        let new_node = _.cloneDeep(node)
        nodeToV2(new_node)

        const target_event_type = new_node.node.properties?.target_event_type ?? rule_event_type

        if (!target_event_type?.environment && target_event_type?.region) {
            target_event_type.environment = getEnvironmentFromRegion(target_event_type.region, rulesList.environment)
        }

        if (new_node.node.properties?.search_with_business_group_key) {
            new_node.node.properties.target_company_key = "every_company"
        } else {
            new_node.node.properties.target_company_key = new_node.node.properties?.target_company_key ?? rule_company_key
        }
        new_node.node.properties.target_event_type = target_event_type

        return new_node
    })

    const enableBusinessGroupQueryOption = (box_settings?.enable_business_group_query_option ?? false)
    const useAdvancedMode = (box_settings?.use_advanced_mode ?? false)

    const [openChangeWarning, setOpenChangeWarning] = useState(false)
    const [clampHintFlash, setClampHintFlash] = useState(false)
    const clampHintFlashTimeoutRef = useRef(null)
    const [open, setOpen] = useState(true)
    const [targetFieldMapping, dispatchTargetFieldMapping] = useReducer(dataFetchReducer,{
        fetchedData: null,
        isLoading: true,
        isError: false,
    })

    useEffect(() => {
        return () => {
            if (clampHintFlashTimeoutRef.current != null) {
                clearTimeout(clampHintFlashTimeoutRef.current)
            }
        }
    }, [])

    const getFilteredCompany = useCallback((targetCompanyKey) => {
        const effectiveKey = targetCompanyKey || rule_company_key
        if (effectiveKey === RULE_PIECE_CURRENT_COMPANY_KEY) {
            return null
        }
        return companyList.filter((comp) => (
            effectiveKey === "every_company" || effectiveKey === comp.company_key
        ))
    }, [rule_company_key, companyList])

    const getEventsForCompany = useCallback((targetCompanyKey) => {
        if (targetCompanyKey === RULE_PIECE_CURRENT_COMPANY_KEY) {
            return getEventTypesIntersectionAcrossCompanies(companyList)
        }
        const filteredCompany = getFilteredCompany(targetCompanyKey)
        if (filteredCompany == null) {
            return []
        }
        let seenEvents = new Set()
        return filteredCompany.flatMap((comp) =>
            (comp.company_events || [])
                .map(event => event.field_mapping.event_type)
                .filter(Boolean)
                .filter(eventType => {
                    const eventEnum = eventType.enum
                    const eventEnvironment = eventType.environment
                    if (seenEvents.has(`${eventEnum}$#$${getRegionFromEnvironment(eventEnvironment)}`)) {
                        return false
                    }
                    seenEvents.add(`${eventEnum}$#$${getRegionFromEnvironment(eventEnvironment)}`)
                    return true
                })
        )
    }, [getFilteredCompany, companyList])

    const concreteCompanyEvents = useMemo(
        () => getEventsForCompany(nodeState?.node?.properties?.target_company_key) || [],
        [getEventsForCompany, nodeState.node.properties.target_company_key]
    )

    const showRulePieceNoSharedEventTypesHint =
        isRulePiece &&
        nodeState?.node?.properties?.target_company_key ===
            RULE_PIECE_CURRENT_COMPANY_KEY &&
        concreteCompanyEvents.length === 0

    const clearEventTypeInfo = (new_node) => {
        const field = new_node.node.properties.fields?.[0] || {type: "dynamic"}
        new_node.node.properties.fields = [
            {...field, target_field_path: null, comparison: null, value: null}
        ]
        setObjectByPath(new_node.node, "properties.dataset", "")
    }

    const [pendingValue, setPendingValue] = useState(null)

    const changeTargetCompanyKey = (newValue, new_node) => {
        if (newValue === "every_company") {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", true)
        } else {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", false)
        }

        const nextEvents = getEventsForCompany(newValue)
        const currentTargetEvent = nodeState?.node?.properties?.target_event_type
        if (nextEvents.length === 1) {
            setObjectByPath(new_node.node, "properties.target_event_type", nextEvents[0])
        } else {
            setObjectByPath(new_node.node, "properties.target_event_type",
                nextEvents.find(event =>
                    event.enum === currentTargetEvent?.enum &&
                    getRegionFromEnvironment(event.environment) === getRegionFromEnvironment(currentTargetEvent?.environment)
                ) || null
            )
        }
        setObjectByPath(new_node.node, "properties.target_company_key", newValue)
        setNodeState(new_node)
    }
    const handleTargetCompanyKeyChange = (e, newValue) => {
        if (areFieldsCleared(nodeState?.node?.properties?.fields)) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetCompanyKey(newValue, new_node)
            return
        }
        setPendingValue({type: "target_company_key", value: newValue})
        setOpenChangeWarning(true)
    }

    const changeTargetEventType = (newValue, new_node) => {
        setObjectByPath(new_node.node, "properties.target_event_type", newValue)
        setNodeState(new_node)
    }
    const handleTargetEventTypeChange = (e, newValue) => {
        if (areFieldsCleared(nodeState?.node?.properties?.fields)) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetEventType(newValue, new_node)
            return
        }
        setPendingValue({type: "target_event_type", value: newValue})
        setOpenChangeWarning(true)
    }

    const getFieldMappingObjectFromEventType = useCallback((targetCompanyKey, targetEventEnum, targetEventEnvironment) => {
        if (!targetEventEnum) return null

        const filteredCompany = targetCompanyKey === RULE_PIECE_CURRENT_COMPANY_KEY
            ? (companyList || []).filter(Boolean)
            : getFilteredCompany(targetCompanyKey)

        if (filteredCompany == null) {
            return null
        }

        const matchingEvent = filteredCompany
            .flatMap(comp => comp.company_events || [])
            .find(event =>
                event.field_mapping?.event_type?.enum === targetEventEnum &&
                getRegionFromEnvironment(event.field_mapping?.event_type?.environment) === getRegionFromEnvironment(targetEventEnvironment)
            )

        return matchingEvent?.field_mapping ?? null
    }, [getFilteredCompany])


    const currentTargetEvent = nodeState?.node?.properties?.target_event_type ?? rule_event_type
    const currentTargetEventEnum = currentTargetEvent?.enum
    const currentTargetEventEnvironment = currentTargetEvent?.environment
    const currentTargetCompanyKey = nodeState?.node?.properties?.target_company_key
    const selectedRegion =
        currentTargetEvent?.region ??
        getRegionFromEnvironment(currentTargetEvent?.environment ?? '')
    const selectedEnum = currentTargetEvent?.enum

    const fieldsMapperList = useMemo(() => rulesList.fields_mapper_list || [], [rulesList])

    useEffect(() => {
        if (!currentTargetEventEnum) return
        if (currentTargetEventEnum === RULE_PIECE_CURRENT_EVENT_ENUM) {
            dispatchTargetFieldMapping({type: "data_fetch_success", payload: {mappings: fieldsMapperList}})
            return
        }
        const targetFieldMappingObject = getFieldMappingObjectFromEventType(currentTargetCompanyKey, currentTargetEventEnum, currentTargetEventEnvironment)
        const targetFieldMappingKey = targetFieldMappingObject?.field_mapping_key
        const targetFieldMappingEnvironment = targetFieldMappingObject?.event_type?.environment

        dispatchTargetFieldMapping({type: "data_fetch_init"})
        const timer = setTimeout(() => {
            axios
            .get(`/dash/rule_engine/event_type/${currentTargetEventEnum}/field_mapping/${targetFieldMappingKey}?environment=${targetFieldMappingEnvironment}`)
            .then((response) => {
                let field_mapping = response.data
                dispatchTargetFieldMapping({type: "data_fetch_success", payload: field_mapping})
            })
            .catch((error) => {
                if ((error.response || {}).status === 403)
                    dispatchTargetFieldMapping({ type: "data_fetch_failure_403" });
                else if ((error.response || {}).status === 404)
                    dispatchTargetFieldMapping({ type: "data_fetch_failure_404" });
                else dispatchTargetFieldMapping({ type: "data_fetch_failure" });
            })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [currentTargetEventEnum,
        currentTargetEventEnvironment,
        currentTargetCompanyKey,
        fieldsMapperList,
        getFieldMappingObjectFromEventType])

    const datasetsForFilter = box_settings?.datasets
    const fetchedMappings = targetFieldMapping?.fetchedData?.mappings
    const fieldMappingIsLoading = targetFieldMapping?.isLoading
    const isFieldMappingAvailable = !!fetchedMappings && !fieldMappingIsLoading

    const compatibleDatasetEntries = useMemo(() => {
        if (!datasetsForFilter || !isFieldMappingAvailable) {
            return []
        }
        return filterDatasetEntries(
            datasetsForFilter,
            fetchedMappings,
            selectedRegion,
            selectedEnum,
        )
    }, [
        datasetsForFilter,
        isFieldMappingAvailable,
        fetchedMappings,
        selectedRegion,
        selectedEnum,
    ])

    useEffect(() => {
        if (read_only || !datasetsForFilter || !isFieldMappingAvailable) {
            return
        }
        if (compatibleDatasetEntries.length !== 1) {
            return
        }
        const onlyKey = compatibleDatasetEntries[0].key
        setNodeState((prev) => {
            if (prev.node.properties.dataset === onlyKey) {
                return prev
            }
            const new_node = _.cloneDeep(prev)
            setObjectByPath(new_node.node, "properties.dataset", onlyKey)
            return new_node
        })
    }, [
        compatibleDatasetEntries,
        read_only,
        isFieldMappingAvailable,
        datasetsForFilter,
    ])

    const formatMaxTimedeltaForHint = (iso) => {
        const duration = moment.duration(iso)
        const parts = []
        const years = duration.years()
        const months = duration.months()
        const days = duration.days()
        const hours = duration.hours()
        const minutes = duration.minutes()
        const seconds = duration.seconds()
        const millis = duration.milliseconds()

        if (years > 0) {
            parts.push(`${years} ${t('years')}`)
        }
        if (months > 0) {
            parts.push(`${months} ${t('months')}`)
        }
        if (days > 0) {
            parts.push(`${days} ${t('days')}`)
        }
        if (hours > 0) {
            parts.push(`${hours} ${t('hours')}`)
        }
        if (minutes > 0) {
            parts.push(`${minutes} ${t('minutes')}`)
        }
        if (seconds > 0) {
            parts.push(`${seconds} ${t('seconds')}`)
        }
        if (millis > 0) {
            parts.push(`${millis} ${t('milliseconds')}`)
        }

        if (parts.length === 0) {
            return `0 ${t('seconds')}`
        }
        return parts.join(', ')
    }

    const validateAllValues = () => {
        if (box_settings?.datasets) {
            if ((nodeState.node.properties.dataset || "").length === 0) {
                return false
            }
            if (
                !targetFieldMapping?.fetchedData?.mappings ||
                targetFieldMapping.isLoading
            ) {
                return false
            }
            if (
                !isCachedDatasetCompatibleWithMappings(
                    nodeState.node.properties.dataset,
                    box_settings.datasets,
                    targetFieldMapping.fetchedData.mappings,
                    selectedRegion,
                    selectedEnum,
                )
            ) {
                return false
            }
        }
        if (!nodeState.node.properties.target_company_key) return false
        if (!nodeState.node.properties.target_event_type) return false

        if ((nodeState.node.properties.fields || []).length === 0) return false

        let seenFields = new Set()
        for (let field of nodeState.node.properties.fields) {
            const stringifiedField = `${field.target_field_path},${field.comparison},${field.value},${field.type}`
            if (seenFields.has(stringifiedField)) {
                return false
            }
            seenFields.add(stringifiedField)
        }

        const mappings =  targetFieldMapping?.fetchedData?.mappings || nodeState.node.properties.target_event_type?.field_mappings
        let hasInvalidFields = false
        if (mappings){
            hasInvalidFields = nodeState.node.properties.fields.some(field => {
                const targetType = mappings?.find(item => item.path === field.target_field_path)?.type;

                return (
                    !field?.target_field_path || field?.target_field_path.length === 0 || field?.comparison == null || field?.comparison === ""
                    || (!field?.value && field.value !== "")
                    || (field.type === "static" && !validateConstantValues(targetType, field.value))
                );
            })
        }

        if (hasInvalidFields) {
            return false
        }

        if (nodeState.node.properties.timedelta_value) {
            if (!validateConstantValues("timedelta", nodeState.node.properties.timedelta_value)) return false
            if (box_settings?.timedelta_value) {
                const settingsDuration = moment.duration(box_settings.timedelta_value)
                const propertiesDuration = moment.duration(nodeState.node.properties.timedelta_value)
                if (propertiesDuration.asMilliseconds() > settingsDuration.asMilliseconds()) {
                    return false
                }
            }
        }


        return true
    }

    const handleValueChange = (path, val) => {
        let new_node = _.cloneDeep(nodeState)
        if (val === "P") val = null
        setObjectByPath(new_node.node,path,val)
        setNodeState(new_node)
    }

    const handleTimedeltaValueChange = (value) => {
        const maxIso = box_settings?.timedelta_value
        if (!maxIso) {
            handleValueChange('properties.timedelta_value', value)
            return
        }
        if (value == null || value === '') {
            handleValueChange('properties.timedelta_value', value)
            return
        }
        if (!validateConstantValues('timedelta', value)) {
            handleValueChange('properties.timedelta_value', value)
            return
        }
        const valueMs = moment.duration(value).asMilliseconds()
        const maxMs = moment.duration(maxIso).asMilliseconds()
        if (valueMs > maxMs) {
            if (clampHintFlashTimeoutRef.current != null) {
                clearTimeout(clampHintFlashTimeoutRef.current)
            }
            setClampHintFlash(true)
            clampHintFlashTimeoutRef.current = setTimeout(() => {
                setClampHintFlash(false)
                clampHintFlashTimeoutRef.current = null
            }, CLAMP_HINT_FLASH_MS)
            handleValueChange('properties.timedelta_value', maxIso)
        } else {
            handleValueChange('properties.timedelta_value', value)
        }
    }

    const handleDatasetChange = (e) => {
        if (e.target.value === "loading") {
            return
        }
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node, "properties.dataset", e.target.value)
        setNodeState(new_node)
    }

    const configurePayload = () => {
        const payload = _.cloneDeep(nodeState)
        const usedFieldPaths = new Set()

        let properties = payload.node.properties
        properties = trimNestedObject(properties)
        properties.fields = (properties.fields || []).map(field => trimNestedObject(field))

        for (let field of properties.fields) {
            if (field.target_field_path) {
                usedFieldPaths.add(field.target_field_path)
            }
        }
        const selectedDatasetKey = properties.dataset
        if (selectedDatasetKey && box_settings?.datasets?.[selectedDatasetKey]) {
            for (const path of box_settings.datasets[selectedDatasetKey]
                .additional_field_paths || []) {
                if (path) {
                    usedFieldPaths.add(path)
                }
            }
        }
        const sourceMappings = targetFieldMapping?.fetchedData?.mappings ||
            properties.target_event_type?.field_mappings ||
            []
        if (properties.target_event_type && sourceMappings.length > 0) {
            properties.target_event_type.field_mappings = sourceMappings.filter(field => usedFieldPaths.has(field.path))
        }

        if (properties.target_event_type) {
            if (
                properties.target_event_type.environment === RULE_PIECE_CURRENT_EVENT_ENVIRONMENT ||
                properties.target_event_type.enum === RULE_PIECE_CURRENT_EVENT_ENUM
            ) {
                properties.target_event_type.region = RULE_PIECE_CURRENT_EVENT_REGION
            } else {
                properties.target_event_type.region = getRegionFromEnvironment(properties.target_event_type.environment)
            }
            delete properties.target_event_type.environment
            delete properties.target_event_type.description
            delete properties.target_event_type.rule_company_key
        }
        if (properties.search_with_business_group_key) {
            delete properties.target_company_key
        }

        payload.node.properties = properties
        return payload
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(configurePayload())
    }

    const handleFilterChange = (event, path) => {
        let new_node = _.cloneDeep(nodeState)

        const { value } = event.target

        if(!new_node.node.properties.filters){
            new_node.node.properties.filters = {}
        }

        if(!new_node.node.properties.filters[path]){
            new_node.node.properties.filters[path] =[]
        }

        new_node.node.properties.filters[path] = value;

        if(new_node.node.properties.filters[path].length === 0){
            delete new_node.node.properties.filters[path]
        }

        if(_.size(new_node.node.properties.filters)=== 0) {
            delete new_node.node.properties.filters
        }
        setNodeState(new_node)
    };

    let options_dictionary = {}
    for(let filter of settingsFilters){
        options_dictionary[filter.path] = {};
        for(let option of filter.options){
            options_dictionary[filter.path][option.enum] = option.description
        }
    }

    let filter_rendered_values = {}
    for(let filter of settingsFilters){
        let translated_values = []
        for(let selected_option of ((nodeState.node.properties.filters||{})[filter.path]||[])){
            translated_values.push(options_dictionary[filter.path][selected_option])
        }
        filter_rendered_values[filter.path] = translated_values.join(', ')
    }

    const handleClose = () => {
        handleConfigurationClose()
        setOpen(false)
    }

    const handleUpdateFields = (updatedFields) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node.properties, "fields", updatedFields)
        setNodeState(new_node)
    }

    return(
            <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        minWidth: "300px",
                        maxWidth: "500px"
                    }
                }
            }}
        >
            <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column", width: "100%", overflow: "auto", overflowX: "hidden"}}>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <span className={["blueText", "titleSize"].join(" ")}>{t(node.node.description)}</span>
                    <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                        <HelpIcon style={{fontSize: "16px", display:"flex", margin:"auto 5px"}}/>
                    </Tooltip>
                </div>

                {nodeState && useAdvancedMode && (
                    <HistoricalDataPicker
                        targetCompanyKey={nodeState.node.properties?.target_company_key}
                        targetEventType={nodeState.node.properties?.target_event_type}
                        companyList={companyList}
                        companyEvents={concreteCompanyEvents}
                        ruleEventType={rule_event_type}
                        isRulePiece={isRulePiece}
                        readOnly={read_only}
                        enableBusinessGroupQueryOption={enableBusinessGroupQueryOption}
                        onCompanyKeyChange={handleTargetCompanyKeyChange}
                        onEventTypeChange={handleTargetEventTypeChange}
                        showRulePieceNoSharedEventTypesHint={showRulePieceNoSharedEventTypesHint}
                    />
                )}

                {box_settings?.datasets ?
                    <div style={{display: "flex", flexDirection: "column", gap: 8, margin: "12px 0 12px 0", width: "100%"}}>
                    <p className={["blueText", "subtitleSize", "labelSpace"].join(" ")} style={{width: "100%", marginLeft: 0}}>{t('dataset')}</p>
                        <TextField
                            label={t('dataset')}
                            error={
                                (isFieldMappingAvailable &&
                                    !(nodeState.node.properties.dataset || "").length) ||
                                (isFieldMappingAvailable &&
                                    Boolean(nodeState.node.properties.dataset) &&
                                    !isCachedDatasetCompatibleWithMappings(
                                        nodeState.node.properties.dataset,
                                        box_settings.datasets,
                                        targetFieldMapping.fetchedData.mappings,
                                        selectedRegion,
                                        selectedEnum,
                                    ))
                            }
                            className="filterTextbox"
                            size="small" fullWidth
                            value={
                                !isFieldMappingAvailable
                                    ? "loading"
                                    : (nodeState.node.properties.dataset || "")
                            }
                            onChange={(e) => handleDatasetChange(e)}
                            select
                            disabled={read_only || !isFieldMappingAvailable}
                            InputProps={{
                                readOnly: read_only
                            }}
                        >
                            {!isFieldMappingAvailable ? (
                                <MenuItem value="loading">
                                    <em className="normalText">{t("Carregando...")}</em>
                                </MenuItem>
                            ) : (
                                compatibleDatasetEntries.map((dataset) => (
                                    <MenuItem key={dataset.key} value={dataset.key}>
                                        {dataset.description}
                                    </MenuItem>
                                ))
                            )}
                        </TextField>
                        {isFieldMappingAvailable &&
                        Object.keys(box_settings.datasets).length > 0 &&
                        compatibleDatasetEntries.length === 0 ? (
                            <FormHelperText>{t("cached_dataset_no_compatible_mappings")}</FormHelperText>
                        ) : null}
                    </div>
                : null}

                <div className="internalCardContainer" style={{display:"flex", flexDirection: "column", margin: "0", width:"100%"}}>
                    <FieldsManager
                        read_only={read_only}
                        fields={nodeState.node.properties.fields}
                        onUpdate={handleUpdateFields}
                        rulesList={rulesList}
                        fieldMapping={targetFieldMapping}
                        userVariables={userVariables}
                        useAdvancedMode={useAdvancedMode}
                    />
                    <p className={["blueText", "subtitleSize"].join(" ")} style={{width: "100%", margin: "0", marginTop: "12px"}}>{t("Configurações")}</p>
                    {settingsFilters.map(filter =>
                        <FormControl key={filter.path} style={{textAlign:"center", width:"100%", margin:"0 auto 12px auto"}}>
                        <InputLabel id="demo-multiple-checkbox-label">{t(filter.description)}</InputLabel>
                        <br></br>
                        <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={((nodeState.node.properties.filters||{})[filter.path]||[])}
                        onChange={(event) => handleFilterChange(event, filter.path)}
                        input={<Input />}
                        renderValue={(selected) => (filter_rendered_values[filter.path])}
                        MenuProps={MenuProps}
                        InputProps={{
                            readOnly: read_only
                        }}
                        >
                        {[...(filter.options || [])].sort((a, b) => (a.description || "").localeCompare(b.description || "")).map((option) => (
                            <MenuItem key={option.enum} value={option.enum} name={option.description}>
                            <Checkbox color="primary" checked={((nodeState.node.properties.filters||{})[filter.path]||[]).includes(option.enum)} />
                            <ListItemText primary={t(option.description)} />
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>)}
                    <TimeDeltaTextField
                        value={nodeState.node.properties.timedelta_value ? nodeState.node.properties.timedelta_value : ""}
                        error={nodeState.node.properties.timedelta_value ? !validateConstantValues("timedelta",nodeState.node.properties.timedelta_value) : false}
                        valueChangeFunction={handleTimedeltaValueChange}
                        label={t("Período de Tempo considerado")}
                        read_only={read_only}
                    />
                </div>
                {box_settings?.timedelta_value ? (
                    <p
                        className={['normalText', 'normalSmallSize'].join(' ')}
                        style={{
                            margin: '0 auto 12px auto',
                            maxWidth: '80%',
                            textAlign: 'center',
                            fontWeight: clampHintFlash ? 'bold' : undefined,
                            color: clampHintFlash ? '#d32f2f' : undefined,
                            opacity: clampHintFlash ? 1 : 0.85,
                            transition: 'color 0.35s ease, opacity 0.35s ease',
                        }}
                    >
                        {t('cached_counter_max_timedelta_hint', {
                            duration: formatMaxTimedeltaForHint(
                                box_settings.timedelta_value,
                            ),
                        })}
                    </p>
                ) : null}
                <div style={{display:"flex"}}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{width:"50%"}}
                        onClick={handleConfigurationClose}
                    >
                        {read_only ? "X" : t("discard")}
                    </div>
                    {!read_only &&
                    <div
                        className={
                            validateAllValues()
                            ?
                            ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                            :
                            ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                        style={{width:"50%"}}
                        onClick={
                            validateAllValues()
                            ? handleSave : null}
                    >
                        {t("save")}
                    </div>}
                </div>
            </div>
            {openChangeWarning && <Dialog
                open={openChangeWarning}
                onClose={() => {
                    setOpenChangeWarning(false)
                    setPendingValue(null)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            minWidth: "250px",
                            maxWidth: "350px"
                        }
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {t("Alterar o tipo de evento limpará os campos configurados")}
                </DialogTitle>
                <DialogContent>
                    <Typography id="alert-dialog-description">
                        {t("Deseja continuar?")}
                    </Typography>
                </DialogContent>
                <DialogActions style={{ display: "flex", padding: "16px 24px", width: "100%" }}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{ width: "50%" }}
                        onClick={() => {
                            setOpenChangeWarning(false)
                            setPendingValue(null)
                        }}
                    >
                        {t("Não")}
                    </div>
                    <div
                        className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                        style={{ width: "50%" }}
                        onClick={() => {
                            const new_node = _.cloneDeep(nodeState)
                            clearEventTypeInfo(new_node)

                            if (pendingValue.type === "target_company_key") {
                                changeTargetCompanyKey(pendingValue.value, new_node)
                            } else if (pendingValue.type === "target_event_type") {
                                changeTargetEventType(pendingValue.value, new_node)
                            }

                            setOpenChangeWarning(false)
                            setPendingValue(null)
                        }}
                    >
                        {t("Sim")}
                    </div>
                </DialogActions>
            </Dialog>}
        </Dialog>
    )
}

function isNodeV1(node){
    const properties = node?.node?.properties
    return (!Array.isArray(properties?.fields) && (Array.isArray(properties?.field_paths) || Array.isArray(properties?.static_fields)))
}

function nodeToV2(node){
    const properties = node?.node?.properties
    const isV1 = isNodeV1(node)

    if (isV1) {
        node.node.properties.fields = translatePathsV1toV2(properties?.field_paths, properties?.static_fields)
        delete node.node.properties.field_paths
        delete node.node.properties.static_fields
        delete node.node.properties.match_number
    }
    return node
}

function translatePathsV1toV2(field_paths, static_fields){
    const newFields = []

    if(Array.isArray(field_paths)){
        field_paths.forEach(field => {
            if(typeof field === "string" && field.trim() !== ""){
                newFields.push({
                    target_field_path: field,
                    value: field,
                    comparison: "equal",
                    type: "dynamic"
                })
            }
        })
    }

    if(Array.isArray(static_fields)){
        static_fields.forEach(field => {
            const type = field?.user_variable_name != null ? "user_variable" : "static"
            if(field && field.field_path) {
                newFields.push({
                    target_field_path: field.field_path,
                    comparison: field.comparison || "equal",
                    value: (type === "user_variable") ? field.user_variable_name : field.value,
                    type: type
                })
            }
        })
    }

    return newFields
}

export class EventFieldCachedCounterBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
        this.formatTimedelta = (timedelta) => {
            const duration = moment.duration(timedelta);

            const years = duration.years();
            const months = duration.months();
            const days = duration.days();
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            let formattedString = '';

            if (years > 0) {
                formattedString += `${years} anos`;
            }

            if (months > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${months} meses`;
            }

            if (days > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${days} dias`;
            }

            if (hours > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${hours} horas`;
            }

            if (minutes > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${minutes} minutos`;
            }

            if (seconds > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${seconds} segundos`;
            }

            return formattedString.trim();
        }
    }
    validate(node){
        const validateNode = _.cloneDeep(node)
        const isV1 = isNodeV1(node)
        nodeToV2(validateNode)
        let put_error = false
        let alerts = []

        if((validateNode.node.children || []).length !== 0){
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }

        const cachedSettings = this.rulesContext?.boxes?.event_field_cached_counter_box?.settings
        if (cachedSettings?.datasets && (validateNode.node.properties.dataset || "").length === 0) {
            put_error = true
            alerts.push("Este nó deve ter um conjunto de dados selecionado")
        }

        if (
            cachedSettings?.datasets &&
            (validateNode.node.properties.dataset || "").length > 0
        ) {
            const targetMappings =
                validateNode.node.properties.target_event_type?.field_mappings ||
                this.rulesContext?.fields_mapper_list ||
                []
            const targetEvt = validateNode.node.properties.target_event_type
            const validateSelectedRegion =
                targetEvt?.region ??
                getRegionFromEnvironment(targetEvt?.environment ?? '')
            const validateSelectedEnum = targetEvt?.enum
            if (
                !isCachedDatasetCompatibleWithMappings(
                    validateNode.node.properties.dataset,
                    cachedSettings.datasets,
                    targetMappings,
                    validateSelectedRegion,
                    validateSelectedEnum,
                )
            ) {
                put_error = true
                alerts.push(
                    "O conjunto de dados selecionado não é compatível com o tipo de evento",
                )
            }
        }

        if(!isV1 && !validateNode.node.properties.target_company_key && !validateNode.node.properties.search_with_business_group_key){
            put_error = true
            alerts.push("Deve ser selecionada uma base histórica para este nó")
        }

        if(!isV1 && !validateNode.node.properties.target_event_type){
            put_error = true
            alerts.push("Deve ser selecionado um tipo de evento para este nó")
        }

        if((validateNode.node.properties.fields || []).length === 0){
            put_error = true
            alerts.push("Este nó deve possuir ao menos um campo configurado")
        }
        else{
            let seenFields = new Set()
            let hasDuplicates = false
            for(let field of validateNode.node.properties.fields){
                const stringifiedField = `${field.target_field_path},${field.comparison},${field.value},${field.type}`
                if(seenFields.has(stringifiedField)){
                    hasDuplicates = true
                    break
                }
                seenFields.add(stringifiedField)
            }

            if (hasDuplicates) {
                put_error = true
                alerts.push("Este nó não deve ter Campos da base histórica duplicados")
            }



            const targetMappings =
                validateNode.node.properties.target_event_type?.field_mappings ||
                this.rulesContext?.fields_mapper_list ||
                []
            let hasInvalidFields = false
            if (targetMappings.length > 0) {
                hasInvalidFields = validateNode.node.properties.fields.some(field => {
                    const fieldType = targetMappings.find(
                        item => item.path === field.target_field_path
                    )?.type

                    return (
                        !field.target_field_path ||
                        field.target_field_path.length === 0 ||
                        field.comparison == null ||
                        field.comparison === "" ||
                        (!field?.value && field.value !== "") ||
                        (field.type === "static" &&
                            (!fieldType ||
                                !validateConstantValues(fieldType, field.value)))
                    )
                })

                if (hasInvalidFields) {
                    put_error = true
                    alerts.push("Todos os Campos deste nó devem ter opções válidas")
                }
            }
        }

        if (validateNode.node.properties.timedelta_value) {
            if (!validateConstantValues("timedelta",validateNode.node.properties.timedelta_value)){
                put_error = true
                alerts.push("Deve ser fornecido um período de tempo válido")
            }
            if (cachedSettings?.timedelta_value) {
                const settingsDuration   = moment.duration(cachedSettings.timedelta_value)
                const propertiesDuration = moment.duration(validateNode.node.properties.timedelta_value)
                if (propertiesDuration.asMilliseconds() > settingsDuration.asMilliseconds()) {
                    put_error = true
                    alerts.push("O período de tempo considerado por esse nó não pode exceder " + this.formatTimedelta(settingsDuration))
                }
            }
        }
        if (validateNode.parentNode != null) {
            if(validateNode.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido")
            }
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        return "number"
    }
}
